<template>
  <v-list-item-group v-model="item" color="primary" style="width: 100%">
    <!-- Header -->
    <v-row v-if="lista.length" style="background-color: #ccc; margin-left: 0px; width: 100%">
      <v-col cols="12" md="1"></v-col>
      <v-col cols="12" md="1">N.</v-col>
      <v-col cols="12" :md="colunasNotas.length > 1 ? '2':'5'">Nome</v-col>
      <v-col v-for="(coluna, idx) in colunasNotas" :key="idx" cols="12" md="1">
        {{ coluna.label }}
      </v-col>
      <v-col cols="12" md="1">Action</v-col>
      <v-col cols="12" md="1">Autor</v-col>
    </v-row>

    <hr v-if="lista.length" />
    <br />

    <v-list-item v-for="(estudante, i) in lista" :key="i">
      <v-list-item-icon>
        <v-icon v-text="estudante.icon"></v-icon>
      </v-list-item-icon>

      <v-row class="bodyLancamentoNotas">
        <v-col cols="12" md="1">
          <img class="photomouse" :src="getPhoto(estudante)" alt="avatar" width="30px" />
        </v-col>

        <v-col cols="12" md="1">{{ i + 1 }}.</v-col>

        <v-col cols="12" :md="colunasNotas.length > 1 ? '2':'5'">
          <v-list-item-title v-text="estudante.nome" />
        </v-col>

        <v-col v-for="(coluna, idx) in colunasNotas" :key="idx" cols="12" md="1">
          <p v-if="editedpk !== estudante.pkpauta || coluna.label === 'MD'" class="text-lowercase">
            {{ estudante[coluna.key] }}
          </p>
          <v-text-field
            v-if="editedpk === estudante.pkpauta && coluna.label !== 'MD'"
            v-model="editedItem[coluna.key]"
            :rules="notaRules"
            single-line
          />
        </v-col>

        <v-col cols="12" md="1">
          <v-btn
            color="red"
            fab
            x-small
            dark
            :disabled="btn_activacao1"
            v-if="pautaBloqueada"
            class="mr-2"
            text
          >
            <v-icon>lock</v-icon>
          </v-btn>

          <v-btn
            color="secondary"
            fab
            x-small
            dark
            class="mr-2"
            :disabled="btn_activacao1"
            v-if="!pautaBloqueada &&
                  editedpk !== estudante.pkpauta &&
                  !estudante.notas_transportadas &&
                  parseInt(estudante.desistente) !== 6 &&
                  parseInt(estudante.desistente) !== 7"
            @click="$emit('editar', estudante)"
          >
            <v-icon>edit</v-icon>
          </v-btn>

          <p v-if="parseInt(estudante.desistente) === 6">Desistente</p>
          <p v-if="parseInt(estudante.desistente) === 7">Matricula Cancelada</p>

          <v-btn
            color="primary"
            fab
            x-small
            dark
            v-if="editedpk === estudante.pkpauta"
            @click="$emit('salvar', editedItem)"
          >
            <v-icon>save_alt</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="12" md="1">
          <span style="font-size: 8px">{{ estudante.autor }} -- {{ estudante.data_2 }}</span>
        </v-col>
      </v-row>
    </v-list-item>
  </v-list-item-group>
</template>

<script>
import photostudent from "../../../../utilitarios/photo.services";
export default {
  name: "LancamentoNotasTrimestre",
  props: {
    lista: Array,
    colunasNotas: Array, // Ex: [{ key: 'p1_notaMac', label: 'Mac' }, ...]
    pautaBloqueada: Boolean,
    editedpk: [String, Number],
    editedItem: Object,
    btn_activacao1: Boolean,
    notaRules: Array,
  },
  emits: ['editar', 'salvar'],
  methods: {
    getPhoto(item) {
       try {
        return photostudent.getPhotoStudent(item.matricula);
      } catch (error) {
        Swal.fire("Informação", "Ocorreu um erro ao carregar a foto", "error");
      }
    }
  }
};
</script>
